<template>
  <div class="cfs-field d-flex flex-column readonly">
    <p class="input-title px-1 pb-1">
      <slot name="label" :label="label">
        {{ sharp ? `${label} #` : label }}
      </slot>
    </p>
    <div class="cfs-field-readonly-value whitespace-pre-wrap d-inline-block">
      <div v-if="loading" class="flex justify-center">
        <v-progress-circular :size="25" color="primary" indeterminate />
      </div>
      <div v-else-if="$hasSlot('value')">
        <slot name="value" />
        <slot name="readonly-append"></slot>
      </div>
      <template v-else>{{ computedValue }}</template>
      <slot name="readonly-append"></slot>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  model: {
    prop: 'data',
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    sharp: {
      type: Boolean,
      default: false,
    },
    keyStr: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, String, Number],
      default: null,
    },
  },
  setup(props) {
    const computedValue = computed(() => {
      if (props.data) {
        return props.data;
      }
      if (props.value?.description) {
        return props.value.description;
      }
      if (!!props.value && typeof props.value !== 'object') {
        return props.value;
      }
      return '-';
    });
    return { computedValue };
  },
};
</script>
